const MultiColorLogo = ({ className = "h-24 sm:h-32" }: { className?: string }) => {
  // Platform colors from platformColors.ts
  const colors = [
    { name: "instagram", hue: "#E1306C", hue2: "#F77737" },
    { name: "youtube", hue: "#FF0000" },
    { name: "tiktok", hue: "#00F2EA", hue2: "#FF0050" },
    { name: "twitter", hue: "#1DA1F2" },
    { name: "facebook", hue: "#4267B2" },
    { name: "telegram", hue: "#0088CC" },
    { name: "spotify", hue: "#1DB954" },
    { name: "linkedin", hue: "#0A66C2" },
    { name: "twitch", hue: "#9146FF" },
    { name: "discord", hue: "#5865F2" },
    { name: "soundcloud", hue: "#FF5500" },
  ];

  return (
    <svg
      viewBox="0 0 320 120"
      className={className}
      style={{ width: "auto" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Animated gradient for the text */}
        <linearGradient id="logo-multi-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#E1306C">
            <animate attributeName="stop-color" values="#E1306C;#FF0000;#00F2EA;#1DA1F2;#4267B2;#0088CC;#1DB954;#9146FF;#FF5500;#E1306C" dur="8s" repeatCount="indefinite" />
          </stop>
          <stop offset="25%" stopColor="#1DA1F2">
            <animate attributeName="stop-color" values="#1DA1F2;#4267B2;#0088CC;#1DB954;#9146FF;#FF5500;#E1306C;#FF0000;#00F2EA;#1DA1F2" dur="8s" repeatCount="indefinite" />
          </stop>
          <stop offset="50%" stopColor="#1DB954">
            <animate attributeName="stop-color" values="#1DB954;#9146FF;#FF5500;#E1306C;#FF0000;#00F2EA;#1DA1F2;#4267B2;#0088CC;#1DB954" dur="8s" repeatCount="indefinite" />
          </stop>
          <stop offset="75%" stopColor="#9146FF">
            <animate attributeName="stop-color" values="#9146FF;#FF5500;#E1306C;#FF0000;#00F2EA;#1DA1F2;#4267B2;#0088CC;#1DB954;#9146FF" dur="8s" repeatCount="indefinite" />
          </stop>
          <stop offset="100%" stopColor="#FF5500">
            <animate attributeName="stop-color" values="#FF5500;#E1306C;#FF0000;#00F2EA;#1DA1F2;#4267B2;#0088CC;#1DB954;#9146FF;#FF5500" dur="8s" repeatCount="indefinite" />
          </stop>
        </linearGradient>

        {/* Glow filter */}
        <filter id="logo-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        {/* Outer glow filter */}
        <filter id="logo-outer-glow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur" />
        </filter>

        {/* Ring gradient */}
        <linearGradient id="ring-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          {colors.map((c, i) => (
            <stop key={c.name} offset={`${(i / (colors.length - 1)) * 100}%`} stopColor={c.hue} />
          ))}
        </linearGradient>
      </defs>

      {/* Colored dots ring around "M" */}
      {colors.map((c, i) => {
        const angle = (i / colors.length) * 360 - 90;
        const rad = (angle * Math.PI) / 180;
        const cx = 45 + Math.cos(rad) * 34;
        const cy = 55 + Math.sin(rad) * 34;
        return (
          <g key={c.name}>
            <circle cx={cx} cy={cy} r="5" fill={c.hue} opacity="0.3" filter="url(#logo-outer-glow)">
              <animate attributeName="opacity" values="0.2;0.5;0.2" dur={`${2 + i * 0.3}s`} repeatCount="indefinite" />
            </circle>
            <circle cx={cx} cy={cy} r="3.5" fill={c.hue} opacity="0.9">
              <animate attributeName="r" values="3;4;3" dur={`${2 + i * 0.3}s`} repeatCount="indefinite" />
            </circle>
          </g>
        );
      })}

      {/* Central "M" letter */}
      <text
        x="45"
        y="68"
        textAnchor="middle"
        fontFamily="Orbitron, monospace"
        fontWeight="900"
        fontSize="42"
        fill="url(#logo-multi-gradient)"
        filter="url(#logo-glow)"
      >
        M
      </text>

      {/* Brand name text */}
      <text
        x="185"
        y="52"
        textAnchor="middle"
        fontFamily="Orbitron, monospace"
        fontWeight="700"
        fontSize="22"
        fill="url(#logo-multi-gradient)"
        filter="url(#logo-glow)"
        letterSpacing="2"
      >
        מחוברים
      </text>

      {/* Subtitle */}
      <text
        x="185"
        y="76"
        textAnchor="middle"
        fontFamily="Rajdhani, sans-serif"
        fontWeight="400"
        fontSize="11"
        fill="hsl(174, 90%, 50%)"
        opacity="0.7"
        letterSpacing="3"
      >
        SOCIAL MEDIA BOOST
      </text>

      {/* Decorative line under subtitle with gradient */}
      <line x1="115" y1="84" x2="255" y2="84" stroke="url(#ring-gradient)" strokeWidth="1" opacity="0.4" />
    </svg>
  );
};

export default MultiColorLogo;
